import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import XHR from 'i18next-xhr-backend';

i18n
  .use(initReactI18next)
  .use(XHR) // passes i18n down to react-i18next
  .init({
    lng: "en",
    lngs: ["en","fr"],
    ns: [
      "translation"
    ],
    //backend: {
      // for all available options read the backend's repository readme file
      //loadPath: '/locales/{{lng}}/{{ns}}.json',
      //allowMultiLoading: true,
      //react: { wait: true }
    //},
    fallbackLng: {
      'en-US': ['en'],
      'fr-FR': ['fr'],
      'fr-CA': ['fr'],
      'en-CA': ['fr'],
      default: ['fr'],
    },
    fallbackNS: "translation",
    keySeparator: false,
    nsSeparator: false,
    keySeparator: false, // we do not use keys in form messages.welcome
    debug: true,
    react: { wait: true },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
